export const NATIONAL_ORGANIZERS = ["LIITTO", "L-S", "HAA"];

export const TOURNAMENT = {
  BYE_ID: "BYE",
  CHAMPION_CUP_NAME: "Champion",
  BOULE_NAMES: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
  BYE_NAME: "--- BYE ---"
};
